import type { ThemeMode } from '../../ui/theme/types'
import { useChallenge } from './useChallenge'
import { useChallengeId } from './useChallengeId'

export function useChallengeTheme(): ThemeMode {
  const challengeId = useChallengeId()
  const { data: challenge } = useChallenge(challengeId)
  return challenge?.theme ?? 'light'
}
